import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";
import { useParams } from "react-router";

const UpdateLibraryFolderManagement = ({ Show, Hide, Title, projectData, getEditorProjectData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [name, setName] = useState("");
  const { studyId } = useParams()

  function replaceLastSegment(path, newSegment) {
    const parts = path.split('/');
    parts[parts.length - 1] = newSegment;
    return parts.join('/');
  }

  const updateFileFolderData = async () => {
    setButtonLoader(true)
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update ${projectData?.type === "folder" ? "Folder Name" : "Library Name"}?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = { studyId };
        userData.id = projectData?._id;
        userData.name = name;
        userData.previousName = `${projectData?.path}/`;
        userData.currentName = `${replaceLastSegment(projectData?.path, name)}/`;
        let data = await editorProjectServices.updateFileFolderData(
          userData
        );
        setButtonLoader(false)
        if (data?.statusCode === 200) {
          getEditorProjectData();
          setName("")
          Hide()
        }
      }
    });
  };

  useEffect(() => {
    setName(projectData?.name)
  }, [projectData]);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{projectData?.type === "folder" ? "Update Folder" : "Update Library"}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              onChange={(e) => setName(e.target.value)}
              value={name}
              className="fontSize12"
              placeholder="Enter Name"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={updateFileFolderData}
            disabled={buttonLoader || !name}
            title={projectData?.type === "folder" ? "Update Folder" : "Update Library"}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              projectData?.type === "folder" ? "Update Folder" : "Update Library"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateLibraryFolderManagement;
